<template>
  <div id="app">
    <div id="nav">
    <nav class="mb-3 navbar navbar-expand-lg navbar-light bg-spinosa">
        <img class="img-fluid" height="50" src="./assets/logo.png" width="50" tabindex="0">
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <div class="nav-item ml-auto"></div>
        </div>
        <div v-if="this.login" style="float:right; color: white"><b-button @click="logout">Logout</b-button></div>
        </nav>   
        <div class="container" v-if="(this.login && this.home === true)">
            <router-link to="/conferimento">Conferimento</router-link> |
            <router-link to="/analisi">Analisi</router-link> |
            <router-link to="/trasformazione">Trasformazione</router-link> |
            <router-link to="/confezionamento">Confezionamento</router-link> |
            <router-link to="/distribuzione">Distribuzione</router-link> |
            <router-link to="/notarizzazione">Notarizzazione</router-link>
        </div>
    </div>
    <router-view/>
  </div>
</template>
<script>
export default {
  name: 'App',
  methods: {
      logout: function () {
         this.$store.dispatch('logout').then(() => 
         this.$router.push('login'))
         this.login = null
      }
  },
  computed: {
      login : function () {
          return this.$store.getters.GET_ACCESSTOKEN
      },
      home : function () {
        //  console.log(this.$route.name)
        if (this.$route.name == 'home') {
            return false
        } else { return true }
      }
  }
}
</script>

<style lang="scss">
#app {
  font-family: 'Roboto', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 90%;
  margin-left: auto;
  margin-right: auto;
  margin-top: 1%;
  margin-bottom: 1%;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
       border-bottom:2px solid #300
      
    }
  }
}
@media only screen and (max-width: 576px) {
#app {
  width: 100%;
  padding: 2%;
}
}
.vue-form-generator *{
    box-sizing:border-box
}
.vue-form-generator .form-control{
    background-clip: padding-box;
    background-color: transparent;
    border: solid rgba(0,0,0,.42);
    border-radius: 0;
    border-width: 0 0 1px;
    box-shadow: none;
    color: rgba(0,0,0,.87);
    display: block;
    font-size: 1rem;
    line-height: 1.5;
    padding: .375rem 0 calc(.375rem - 1px);
    width: 100%;
}

.vue-form-generator .form-control:not([class*=" col-"]){
    width:100%;
}
.vue-form-generator span.help{
    margin-left:.3em;
    position:relative
}
.vue-form-generator span.help .icon{
    display:inline-block;
    width:16px;
    height:14px;
    background-image:url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QA/wD/AP+gvaeTAAAA+UlEQVQ4ja3TS0oDQRAG4C8+lq7ceICICoLGK7iXuNBbeAMJuPVOIm7cqmDiIncIggg+cMZFaqCnZyYKWtB0df31V1VXdfNH6S2wD9CP8xT3KH8T9BiTcE7XBMOfyBcogvCFO9ziLWwFRosyV+QxthNsA9dJkEYlvazsQdi3sBv6Ol6TBLX+HWT3fcQZ3vGM5fBLk+ynAU41m1biCXvhs4OPBDuBpa6GxF0P8YAj3GA1d1qJfdoS4DOIcIm1DK9x8iaWeDF/SP3QU6zRROpjLDFLsFlibx1jJaMkSIGrWKntvItcyTBKzCcybsvc9ZmYz3kz9Ooz/b98A8yvW13B3ch6AAAAAElFTkSuQmCC");
    background-repeat:no-repeat;
    background-position:50%
}
.vue-form-generator span.help .helpText{
    background-color:#444;
    bottom:30px;
    color:#fff;
    display:block;
    left:0;
    opacity:0;
    padding:20px;
    pointer-events:none;
    position:absolute;
    text-align:justify;
    width:300px;
    transition:all .25s ease-out;
    box-shadow:2px 2px 6px rgba(0,0,0,.5);
    border-radius:6px
}
.vue-form-generator span.help .helpText a{
    font-weight:700;
    text-decoration:underline
}
.vue-form-generator span.help .helpText:before{
    bottom:-20px;
    content:" ";
    display:block;
    height:20px;
    left:0;
    position:absolute;
    width:100%
}
.vue-form-generator span.help:hover .helpText{
    opacity:1;
    pointer-events:auto;
    transform:translateY(0)
}
.vue-form-generator .field-wrap{
    display:flex;
    display: table;
    margin: 0 auto;
    width: 100%;
}
.vue-form-generator .field-wrap .buttons{
    white-space:nowrap;
    margin-left:4px
}
.vue-form-generator .field-wrap button,.vue-form-generator .field-wrap input[type=submit]{
    margin-left: auto;
    margin-right: auto;
    display:inline-block;
    padding:6px 12px;
    font-size:14px;
    font-weight:400;
    line-height:1.42857143;
    text-align:center;
    white-space:nowrap;
    vertical-align:middle;
    touch-action:manipulation;
    cursor:pointer;
    user-select:none;
    color:#333;
    background-color:#fff;
    border:1px solid #ccc;
    border-radius:4px
}
.vue-form-generator .field-wrap button:not(:last-child),.vue-form-generator .field-wrap input[type=submit]:not(:last-child){
    margin-right:4px
}
.vue-form-generator .field-wrap button:hover,.vue-form-generator .field-wrap input[type=submit]:hover{
    color:#333;
    background-color:#e6e6e6;
    border-color:#adadad
}
.vue-form-generator .field-wrap button:active,.vue-form-generator .field-wrap input[type=submit]:active{
    color:#333;
    background-color:#d4d4d4;
    border-color:#8c8c8c;
    outline:0;
    box-shadow:inset 0 3px 5px rgba(0,0,0,.125)
}
.vue-form-generator .field-wrap button:disabled,.vue-form-generator .field-wrap input[type=submit]:disabled{
    opacity:.6;
    cursor:not-allowed
}
.vue-form-generator .hint{
    font-style:italic;
    font-size:.8em
}
.form-group:not([class*=" col-"]){
    width:100%
}
.form-group{
    display:inline-block;
    vertical-align:top;
    margin-bottom:1rem;
}
.form-group label{
    font-weight:400
}
.form-group label>:first-child{
    display:inline-block
}
.form-group.featured>label{
    font-weight:700
}
.form-group.required>label:after{
    content:"*";
    font-weight:400;
    color:red;
    padding-left:.2em;
    font-size:1em
}
.form-group.disabled>label{
    color:#666;
    font-style:italic
}
.form-group.error input:not([type=checkbox]),.form-group.error select,.form-group.error textarea{
    border:1px solid #520008;
    background-color:rgba(255,0,0,.15)
}
.form-group.error .errors{
    color:red;
    font-size:.8em
}
.form-group.error .errors span{
    display:block;
    background-image:url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAiklEQVR4Xt2TMQoCQQxF3xdhu72MpZU3GU/meBFLOztPYrVWsQmEWSaMsIXgK8P8RyYkMjO2sAN+K9gTIAmDAlzoUzE7p4IFytvDCQWJKSStYB2efcAvqZFM0BcstMx5naSDYFzfLhh/4SmRM+6Agw/xIX0tKEDFufeDNRUc4XqLRz3qabVIf3BMHwl6Ktexn3nmAAAAAElFTkSuQmCC");
    background-repeat:no-repeat;
    padding-left:17px;
    padding-top:0;
    margin-top:.2em;
    font-weight:600
}
.vue-form-generator .field-checkbox {
    overflow: hidden;
    width: 46%;
    min-height: 100px;
    height: auto;
    display: inline-block;
    margin-top: 1%;
}
.vue-form-generator .field-checkbox label, .form-group.valid.field-input,label > span{
   margin: auto;
   font-weight: bold;
}
.vue-form-generator .field-checkbox input{
    overflow: hidden;
    margin-left:auto;
    margin-right: auto; 
    margin-top:2%  
}
.vue-form-generator .field-checklist .dropList,.vue-form-generator .field-checklist .listbox{
    height:auto;
    max-height:150px;
    overflow:auto
}
.vue-form-generator .field-checklist .dropList .list-row label,.vue-form-generator .field-checklist .listbox .list-row label{
    font-weight:400
}
.vue-form-generator .field-checklist .dropList .list-row input,.vue-form-generator .field-checklist .listbox .list-row input{
    margin-right:.3em
}
.vue-form-generator .field-checklist .combobox{
    height:auto;
    overflow:hidden
}
.vue-form-generator .field-checklist .combobox .mainRow{
    cursor:pointer;
    position:relative;
    padding-right:10px
}
.vue-form-generator .field-checklist .combobox .mainRow .arrow{
    position:absolute;
    right:-9px;
    top:3px;
    width:16px;
    height:16px;
    transform:rotate(0deg);
    transition:transform .5s;
    background-image:url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEwAACxMBAJqcGAAAAGdJREFUOI3tzjsOwjAURNGDUqSgTxU5K2AVrJtswjUsgHSR0qdxAZZFPrS+3ZvRzBsqf9MUtBtazJk+oMe0VTriiZCFX8nbpENMgfARjsn74vKj5IFruhfc8d6zIF9S/Hyk5HS4spMVeFcOjszaOwMAAAAASUVORK5CYII=");
    background-repeat:no-repeat
}
.vue-form-generator .field-checklist .combobox .mainRow.expanded .arrow{
    transform:rotate(-180deg)
}
.vue-form-generator .field-checklist .combobox .dropList{
    transition:height .5s
}
.vue-form-generator .field-input .wrapper,.vue-form-generator .field-input input[type=radio]{
    width:100%
}
.vue-form-generator .field-input input[type=color]{
    width:60px
}
.vue-form-generator .field-input input[type=range]{
    padding:0
}
.vue-form-generator .field-input .helper{
    margin:auto .5em
}
.vue-form-generator .field-label span{
    display:block;
    width:100%;
}
.vue-form-generator .field-radios .radio-list label{
    display:block
}
.vue-form-generator .field-radios .radio-list label input[type=radio]{
    margin-right:5px
}
.vue-form-generator .field-submit input,.btn,button,{
    color:#fff!important;
    background-color:#300!important;
    border-color:#520008!important
}
.vue-form-generator .field-submit input:hover,.btn:hover,button:hover{
    color: #300!important;
    background-color:#fff!important;
    border-color:#520008!important;
}
.vue-form-generator .field-input .wrapper{
    width:100%
}
.vue-form-generator .field-input .helper{
    margin:auto .5em
}
.vue-form-generator .field-image .wrapper{
    width:100%
}
.vue-form-generator .field-image .preview{
    position:relative;
    margin-top:5px;
    height:100px;
    background-repeat:no-repeat;
    background-size:contain;
    background-position:50%;
    border:1px solid #ccc;
    border-radius:3px;
    box-shadow:inset 0 1px 1px rgba(0,0,0,.075)
}
.vue-form-generator .field-image .preview .remove{
    background-image:url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAXUlEQVR42u2SwQoAIAhD88vVLy8KBlaS0i1oJwP3piGVg0Skmpq8HjqZrWl9uwCbGAmwKYGZs/6iqgMyAdJuM8W2QmYKpLt/0AG9ASCv/oAnANd3AEjmAlFT1BypAV+PnRH5YehvAAAAAElFTkSuQmCC");
    width:16px;
    height:16px;
    font-size:1.2em;
    position:absolute;
    right:.2em;
    bottom:.2em;
    opacity:.7
}
.vue-form-generator .field-image .preview .remove:hover{
    opacity:1;
    cursor:pointer
}
.vue-form-generator .field-noUiSlider .field-wrap{
    display:block
}
.vue-form-generator .field-noUiSlider .contain-pips{
    margin-bottom:30px
}
.vue-form-generator .field-noUiSlider .contain-tooltip{
    margin-top:30px
}
.vue-form-generator .field-noUiSlider .noUi-vertical{
    height:200px;
    margin:10px 0
}
.vue-form-generator .field-rangeSlider .irs{
    width:100%
}
.vue-form-generator .field-selectEx .bootstrap-select .dropdown-menu li.selected .text{
    font-weight:700
}
.vue-form-generator .field-staticMap img{
    display:block;
    width:auto;
    max-width:100%
}
.vue-form-generator .field-switch .field-wrap label{
    position:relative;
    display:block;
    width:120px;
    height:30px;
    padding:0;
    margin:0 10px 10px 0;
    border-radius:15px;
    box-shadow:inset 0 -1px #fff,inset 0 1px 1px rgba(0,0,0,.05);
    cursor:pointer
}
.vue-form-generator .field-switch input{
    position:absolute;
    top:0;
    left:0;
    opacity:0
}
.vue-form-generator .field-switch .label{
    position:relative;
    display:block;
    height:inherit;
    font-size:10px;
    text-transform:uppercase;
    background:#eceeef;
    border-radius:inherit;
    box-shadow:inset 0 1px 2px rgba(0,0,0,.12),inset 0 0 2px rgba(0,0,0,.15)
}
.vue-form-generator .field-switch .label:after,.vue-form-generator .field-switch .label:before{
    position:absolute;
    top:50%;
    margin-top:-.5em;
    line-height:1;
    -webkit-transition:inherit;
    -moz-transition:inherit;
    -o-transition:inherit;
    transition:inherit
}
.vue-form-generator .field-switch .label:before{
    content:attr(data-off);
    right:11px;
    color:#aaa;
    text-shadow:0 1px hsla(0,0%,100%,.5)
}
.vue-form-generator .field-switch .label:after{
    content:attr(data-on);
    left:11px;
    color:#fff;
    text-shadow:0 1px rgba(0,0,0,.2);
    opacity:0
}
.vue-form-generator .field-switch input:checked~.label{
    background:#e1b42b;
    box-shadow:inset 0 1px 2px rgba(0,0,0,.15),inset 0 0 3px rgba(0,0,0,.2)
}
.vue-form-generator .field-switch input:checked~.label:before{
    opacity:0
}
.vue-form-generator .field-switch input:checked~.label:after{
    opacity:1
}
.vue-form-generator .field-switch .handle{
    position:absolute;
    top:1px;
    left:1px;
    width:28px;
    height:28px;
    background:linear-gradient(180deg,#fff 40%,#f0f0f0);
    background-image:-webkit-linear-gradient(top,#fff 40%,#f0f0f0);
    border-radius:100%;
    box-shadow:1px 1px 5px rgba(0,0,0,.2)
}
.vue-form-generator .field-switch .handle:before{
    content:"";
    position:absolute;
    top:50%;
    left:50%;
    margin:-6px 0 0 -6px;
    width:12px;
    height:12px;
    background:linear-gradient(180deg,#eee,#fff);
    background-image:-webkit-linear-gradient(top,#eee,#fff);
    border-radius:6px;
    box-shadow:inset 0 1px rgba(0,0,0,.02)
}
.vue-form-generator .field-switch input:checked~.handle{
    left:91px;
    left:calc(100% - 29px);
    box-shadow:-1px 1px 5px rgba(0,0,0,.2)
}
.vue-form-generator .field-switch .handle,.vue-form-generator .field-switch .label{
    transition:all .3s ease
}

.field-submit input,.bg-spinosa,.btn-info.btn-block{
    background-color: #300;
    color: #fff;
    border-color: #400!important;
    transition: color 1s ease;
    transition: background-color 1s ease;

}
.btn-info:hover,.btn-info[aria-expanded=false] {

    color: #300!important;
    background-color: rgba(54, 1, 1, 0.5)!important;
    border-color: #300!important;

}
.btn-info:focus, .btn-info.focus{
    -webkit-box-shadow: none!important;
    box-shadow: none!important;
}

#nav{
    padding: 0px;
}
.navbar {
    -ms-flex-align: center;
    -ms-flex-pack: justify;
    -ms-flex-wrap: wrap;
    align-items: center;
    color: rgba(0,0,0,.87);
    display: -ms-flexbox;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    min-height: 3.5rem;
    padding: .625rem 1rem;
    position: relative;
}

.btn:not(:disabled):not(.disabled) {
    cursor: pointer;
}

label > span ,.label{
  text-transform: uppercase;
  font-size: 0.8rem;
}
.form-group.valid.field-input,.form-group.valid.field-vueMultiSelect,.form-group.valid.field-checkbox,.form-group.valid.field-select,.form-group.valid.field-object,.form-group.valid.field-file,.table-component{
    padding: 2%;
    margin-bottom: 1%;
}
input[type=submit]{
    font-size: 1rem!important;
    margin-left: auto;
    margin-right: auto;
}
#app > div.panel-body > div > fieldset > div.form-group.valid.field-object > label > span{
    font-size:150%;
}

table, th, td {
  border: 1px solid black;
}
.table-component__filter > input{
    margin-bottom: 2%;
}
.table-component__table{
    font-size:0.9rem;
    margin-left: auto;
    margin-right: auto;
}
#loader {
	position: fixed;
	width: 100%;
	height: 100%;
	background: #fff url("data:image/svg+xml;base64,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") no-repeat 50% 40%;
	background-size: 130px 32px;
	z-index: 300
}

#loader .lds-dual-ring {
	display: inline-block;
	width: 64px;
	height: 64px;
	position: absolute;
	left: 50%;
	top: 40%;
	margin: 32px 0 0 -23px
}

#loader .lds-dual-ring:after {
	content: " ";
	display: block;
	width: 46px;
	height: 46px;
	margin: 1px;
	border-radius: 50%;
	border: 5px solid #372728;
	border-color: #372728 transparent #372728 transparent;
	animation: lds-dual-ring 1.2s linear infinite
}

@keyframes lds-dual-ring {
	0% {
		transform: rotate(0deg)
	}
	100% {
		transform: rotate(360deg)
	}
}
</style>
